export default "__VITE_ASSET__B_w4LR4Q__"